import { useNavigate, NavigateOptions, To } from 'react-router-dom';

export const useNavigateWithParams = () => {
  const navigate = useNavigate();

  return (to: To | number, options?: NavigateOptions) => {
    if (typeof to === 'string') {
      // Parse the destination URL
      const [pathname, search] = to.split('?');
      
      // Get current query params
      const currentParams = new URLSearchParams(window.location.search);
      
      // Remove auth param - we never want to propagate it
      currentParams.delete('auth');
      
      // Get destination query params (if any)
      const destParams = new URLSearchParams(search || '');
      
      // Merge params: destination params override current params
      destParams.forEach((value, key) => {
        currentParams.set(key, value);
      });
      
      // Build final URL
      const finalSearch = currentParams.toString();
      const newPath = finalSearch ? `${pathname}?${finalSearch}` : pathname;
      
      return navigate(newPath, options);
    }
    return navigate(to as To, options);
  };
};
